import axios from 'axios';
import { ShowNotifyPopup } from 'components/common/popup/popup';
import { AuthState } from 'contexts/authContext';
import Config from 'utils/config';
import Helpers from 'utils/helpers';

const DEBUG = true;

axios.defaults.baseURL = Config.apiURL;
//axios.defaults.responseType = 'application/json';

//setup global error management for api errors
if (process.browser) {
  axios.interceptors.response.use(
    function (response) {
      if (response && response.status === 401) {
        //window.location = '/Logout';
      }
      return response;
    },
    function (error) {
      respondToApiError(error);
      return Promise.reject(error);
    }
  );
}

//setup interceptor to add authentication token to header
if (process.browser) {
  axios.interceptors.request.use(
    function (requestConfig) {
      if (requestConfig.withCredentials !== true && !requestConfig.headers.Authorization && AuthState.token) {
        requestConfig.headers.Authorization = `Bearer ${AuthState.token}`;
      }
      requestConfig.headers['Content-Type'] = 'application/json';
      return requestConfig;
    }
  );
}

//setup interceptor to update active call count
if (process.browser) {
  axios.interceptors.request.use(
    function (requestConfig) {
      debugRequest(requestConfig);
      if (requestConfig.headers['background'] !== 'true')
        setActiveCallsTotal(totalActiveCalls + 1);
      return requestConfig;
    },
    function (requestError) {
      return Promise.reject(requestError);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      if (response.config.headers['background'] !== 'true')
        setActiveCallsTotal(totalActiveCalls - 1);
      return response;
    },
    function (responseError) {
      setActiveCallsTotal(totalActiveCalls - 1);
      return Promise.reject(responseError);
    }
  );
}

let callbackFunction = null;
let totalActiveCalls = 0;

function setActiveCallsTotal(newValue) {
  totalActiveCalls = newValue;
  if (callbackFunction) {
    callbackFunction(newValue);
  }
}

function getActiveCallsTotal() {
  return totalActiveCalls;
}

function setActiveCallsUpdateCallback(callback, shouldTriggerNow) {
  if ((callback && !callbackFunction) || (callback.toString() !== callbackFunction.toString())) {
    callbackFunction = callback;
    if (shouldTriggerNow) {
      if (callbackFunction) {
        callbackFunction(totalActiveCalls);
      }
    }
  }
}

function debugRequest(requestConfig) {
  if (Config.debug === true && DEBUG === true) {
    const method = Helpers.Object.isString(requestConfig.method) ? Helpers.String.toUpper(requestConfig.method) : '';
    const url = axios.getUri(requestConfig);
    console.log(`API ${method} ${url}`);
  }
}

function debugResponse(responseConfig, response) {
  if (Config.debug === true && DEBUG === true) {
    if (responseConfig) {
      const method = Helpers.Object.isString(responseConfig.method) ? Helpers.String.toUpper(responseConfig.method) : '';
      const url = axios.getUri(responseConfig);
      console.log(`Status ${response.status} from API ${method} ${url}`);
      console.log(response.data);
    }
  }
}

function respondToApiError(error) {
  if (error) {
    debugResponse(error.config, error.response);
    if (error.config && error.config.url && error.config.url.endsWith('Account/Authenticate')) {
      //error messages are already handled on login pages
      return;
    }
    else if (error.response && error.response.status === 480) {
      //let custom error messages be handled themselves
      return;
    }
    else if (error.response && error.response.status === 401) {
      //redirect any unathorized errors to login page
      window.location = '/Logout';
      return;
    }
    else {
      let title = 'Error';
      if (error.response) {
        title = error.response.statusText || `Error ${error.response.status}`;
      }
      else if (error.name) {
        title = error.name;
      }

      let message = '';
      if (error.response && error.response.data) {
        message = error.response.data.error;
      }
      else {
        message = error.toString().replace('Error: ', '');
      }

      ShowNotifyPopup({
        title: title,
        message: message,
        variant: 'danger',
        yPosition: 'bottom',
        xPosition: 'center',
        showClose: false,
        seconds: 5,
      });
    }
  }
}




const ApiService = {
  getActiveCallsTotal,
  setActiveCallsUpdateCallback,
};

export default ApiService;